<template>
  <div class="container-html">
    <div class="sc-message--text" :style="messageColors">
      <p class="sc-message--text-content" v-html="messageText"></p>
      <p v-if="message.data.meta" class='sc-message--meta' :style="{color: messageColors.color}">{{message.data.meta}}</p>
    </div>
    <div class="container-multiple-values">
      <OptionComponent
        v-for="(option, idx) in message.data.options"
        :key="option.key"
        :option="option"
        :white="idx % 2 === 0"
        :lastMessage="lastMessage"
        :chatbotColors="chatbotColors"
        v-model="selections" />
    </div>
    <div class="options-container">
      <button type="button" class="botao" :style="{ backgroundColor: chatbotColors.sentMessage.bg, color: chatbotColors.sentMessage.text }" @click.prevent="continueWithOptions" :disabled="lastMessage === false || selections.length === 0">CONTINUAR</button>
    </div>
  </div>
</template>

<script>
import escapeGoat from 'escape-goat'
import store from "./../store/"
import OptionComponent from '../components/multiple-selections/Option.vue'

export default {
  components: {
    OptionComponent
  },
  props: {
    message:{
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    chatbotColors: {
      type: Object,
      required: true
    },
    lastMessage: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      store,
      selections: [],
    }
  },
  computed: {
    messageText() {
      const escaped = this.me
        ? escapeGoat.escape(this.message.data.text)
        : this.message.data.text;

      return escaped;
    },
    me(){
      return this.message.author === 'me';
    }
  },
  methods: {
    continueWithOptions () {
      const options = this.message.data.options.filter(option => {
        return this.selections.includes(option.key);
      });

      const text = options.map(option => '- ' + option.value);

      window.EventBus.$emit('ON_MESSAGE_WAS_SENT', {
        author: 'me',
        type: 'text',
        bot: true,
        data: { key: null, text: text.join('<br>'), metadata: options }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.sc-message--text {
  margin-right: 0 !important;
}
.sc-message--text-content {
  -webkit-perspective: 0px !important;
  -webkit-backface-visibility: visible !important;
  -webkit-transform: translate3d(0,0,0) !important;
}
a.chatLink {
  color: inherit !important;
}
.container-multiple-values {
  width: 100%;
  margin-top: 10px
}
.options-container {
  margin-top: 10px;

  .botao {
    display: inline-block;
    margin: 0 5px 5px 0;
    padding: 10px 15px;
    border-radius: 20px;
    font-size: 14px;
    line-height: 1.4;
    position: relative;
    -webkit-font-smoothing: subpixel-antialiased;
    border: 0;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      opacity: .8;
    }
    &:disabled {
      opacity: .3;
      cursor: not-allowed;
    }
  }
}
</style>
